import { combineReducers } from 'redux';
import getNotifications from './get-notifications';
import getUnreadCount from './get-unread-count';
import markAsRead from './mark-as-read';
import markAllAsRead from './mark-all-as-read';

const reducer = combineReducers({
  notifications: getNotifications,
  unreadCount: getUnreadCount,
  markAsRead,
  markAllAsRead,
});

export default reducer;
